import React, { Component } from "react";
import { getVideos } from "../../actions/videoActions";
import { getPAS, createPAS } from "../../actions/pasActions";
import { connect } from "react-redux";
import TextFieldGroup from "../common/TextFieldGroup";
import FileUpload from "../common/FileUpload";
import moment from "moment";
import ToggleButton from "react-toggle-button";
import Select from "react-select";
import PropTypes from "prop-types";
import isEmpty from "../../validation/is-empty";
import { clearFile } from "../../actions/courseActions";

class CreatePas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      video: "",
      selectedOption: null, // Selected Video
      document: "",
      datePublished: moment(),
      published: false,
      attachments: [],
      filename: "",
      errors: {}
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleAddDownload = this.handleAddDownload.bind(this);
  }
  componentDidMount() {
    this.props.getVideos();
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSelectChange = selectedOption => {
    this.setState({ selectedOption });
  };

  handleSubmit(e) {
    e.preventDefault();

    const payload = {
      post: {
        title: this.state.name,
        video: this.state.selectedOption,
        documents: this.state.attachments,
        datePublished: moment(this.state.datePublished._d).format("YYYY/MM/DD"),
        published: this.state.published
      }
    };

    console.log(payload);

    this.props.createPAS(payload, this.props.history);
  }

  // === Attachments start ===

  handleAddDownload() {
    const { attachments, filename } = this.state;
    const newArej = attachments;
    const newAjtem = {
      label: filename,
      value: this.props.courses.file
    };
    if (this.props.courses.file !== null) {
      newArej.push(newAjtem);
      this.setState({
        attachments: newArej,
        filename: ""
      });
    }
    this.props.clearFile();
  }

  handleDownloads() {
    const { errors, id, filename } = this.state;

    return (
      <div className="mt-3">
        <div>
          <div className="row">
            <div className="col-8">
              <TextFieldGroup
                placeholder="filename"
                name="filename"
                type="name"
                value={filename}
                onChange={this.handleChange}
                error={errors.name}
              />
            </div>

            <div className="col-2" />

            <div className="col-2">
              <div>
                <button
                  onClick={this.handleAddDownload}
                  className="btn btn-link"
                >
                  Add
                </button>
              </div>
            </div>
          </div>
        </div>

        <div>
          <FileUpload />
        </div>
      </div>
    );
  }

  deleteDl(index) {
    let arej = this.state.attachments;
    arej.splice(index, 1);
    this.setState({
      attachments: arej
    });
  }

  renderDownloads() {
    const { attachments } = this.state;

    if (isEmpty(attachments) === true) {
      return <div>No attachments</div>;
    } else {
      const renderDls = attachments.map((dl, index) => {
        return (
          <li key={dl.value} className="list-group-item">
            <div className="row">
              <div className="col-6">{dl.label}</div>
              <div className="col-5">{dl.value}</div>
              <div className="col-1">
                <i
                  onClick={() => this.deleteDl(index)}
                  className="fas fa-trash-alt"
                />
              </div>
            </div>
          </li>
        );
      });
      return renderDls;
    }
  }

  // === Attachments end ===

  render() {
    const {
      name,
      video,
      document,
      datePublished,
      published,
      errors
    } = this.state;
    const { videos } = this.props.videos;

    let options; // options for select
    if (videos) {
      options = videos;
    }
    const { selectedOption } = this.state;

    return (
      <div className="wrapper-alt">
        <div className="container">
          <div className="d-flex justify-content-between mt-3 mb-3">
            <div>
              <h1>Add post</h1>
            </div>

            <div>
              <button
                onClick={this.handleSubmit}
                to="/admin/dashboard/pas/create"
                className="btn btn-pp"
              >
                Create
              </button>
            </div>
          </div>

          <TextFieldGroup
            placeholder="name"
            name="name"
            type="name"
            value={name}
            onChange={this.handleChange}
            error={errors.name}
          />

          <div className="mb-5">
            <h3>Select a video:</h3>
            <Select
              value={selectedOption}
              onChange={this.handleSelectChange}
              options={options}
              isSearchable={true}
              isClearable={true}
            />
          </div>

          <div>
            <h3>Attachments</h3>
            <div>
              <div>{this.handleDownloads()}</div>
              <div className="row mt-2">
                <div className="col-6">Filename</div>
                <div className="col-5">Link</div>
                <div className="col-1" />
              </div>
              <ul className="list-group">{this.renderDownloads()}</ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  videos: state.videos,
  courses: state.courses
});

export default connect(
  mapStateToProps,
  { getVideos, createPAS, clearFile }
)(CreatePas);
